import React from "react";
import { Link } from "react-router-dom";
import "./HomeQuickLinks.css";
import administartionImage from "./academics.JPG";
import researchImage from "./Research.JPG";
import academicsImage from "./Admissions.JPG" ;


const HomeQuickLinks = () => {
  return (
    <>
    
    <section className="home-section">
      <div className="home-container">

        {/* Academics */}
        <div className="home-card">
          <div className="home-content">
            <h2>Academics</h2>
            <span className="home-line"></span>
            <p>
              Undergraduate, Postgraduate and Ph.D. programmes.
            </p>
            <Link to="/academic" className="home-btn">
              Learn More
            </Link>
          </div>
          <div className="home-image">
            <img src={administartionImage} alt="Academics" />
          </div>
        </div>

        {/* Admissions */}
        <div className="home-card">
          <div className="home-content">
            <h2>Admissions</h2>
            <span className="home-line"></span>
            <p>
              Admission process, eligibility and notifications.
            </p>
            <Link to="/admission" className="home-btn">
              Apply Now
            </Link>
          </div>
          <div className="home-image">
            <img src={academicsImage} alt="Admissions" />
          </div>
        </div>

        {/* Research */}
        <div className="home-card">
          <div className="home-content">
            <h2>Research</h2>
            <span className="home-line"></span>
            <p>
              Research, projects and publications.
            </p>
            <Link to="/research" className="home-btn">
              Explore
            </Link>
          </div>
          <div className="home-image">
            <img src={researchImage} alt="Research" />
          </div>
        </div>

      </div>
    </section>
   
    </>
  );
};

export default HomeQuickLinks;
